// @ts-ignore
// @ts-nocheck

import type {
  ITrackingEvent,
  ITrackingIdentity,
  ITrackingUpdate
} from '@/models/interfaces'
import type { App } from 'vue'
import httpClient from '@/httpClient'
import { DateTime } from 'luxon'

export default {
  install: function (app: App) {
    // Currently using Bloomreach Data Hub Web SDK for user tracking
    // This plugin installs the brweb SDK and exposes various functions for identifying and tracking user activity

    // Determine if we're in a non-production environment
    const isNonProduction = import.meta.env.MODE !== 'production'

    !(function (e, t, n, i, o, r) {
      const s = 4e3,
        c = 'xnpe_async_hide'
      function a(e) {
        if ('number' != typeof e) return e
        const t = new Date()
        return new Date(t.getTime() + 1e3 * e)
      }
      function m(e) {
        return e.reduce(
          function (e, t) {
            return (
              (e[t] = function () {
                e._.push([t.toString(), arguments])
              }),
              e
            )
          },
          { _: [] }
        )
      }
      function p(e, t, n) {
        const i = n.createElement(t)
        i.src = e
        const o = n.getElementsByTagName(t)[0]
        return (o.parentNode.insertBefore(i, o), i)
      }
      function l(e) {
        return '[object Date]' === Object.prototype.toString.call(e)
      }
      ;((r.target = r.target || 'https://api.exponea.com'),
        (r.file_path = r.file_path || r.target + '/js/brweb.min.js'),
        (o[t] = m([
          'anonymize',
          'initialize',
          'identify',
          'getSegments',
          'update',
          'track',
          'trackLink',
          'trackEnhancedEcommerce',
          'getHtml',
          'showHtml',
          'showBanner',
          'showWebLayer',
          'ping',
          'getAbTest',
          'loadDependency',
          'getRecommendation',
          'reloadWebLayers',
          '_preInitialize',
          '_initializeConfig',
          'metadata'
        ])),
        (o[t].notifications = m([
          'isAvailable',
          'isSubscribed',
          'subscribe',
          'unsubscribe'
        ])),
        (o[t].segments = m(['subscribe'])),
        (o[t]['snippetVersion'] = 'v3.1.1'),
        (function (e, t, n, i) {
          e[i] = {
            sdk: e[n],
            sdkObjectName: n,
            skipExperiments: !!t.new_experiments,
            path: t.target,
            streamId: t.stream_id
          }
        })(o, r, t, i),
        (function (e, t, n) {
          p(e.file_path, t, n)
        })(r, n, e),
        (function (e, t, n, i, o, r, m, u) {
          if (!e.new_experiments) return
          !0 === e.new_experiments && (e.new_experiments = {})
          const f = e.new_experiments.hide_class || c,
            d = e.new_experiments.timeout || s,
            _ = encodeURIComponent(r.location.href)
          let g
          ;(e.cookies &&
            e.cookies.expires &&
            ('number' == typeof e.cookies.expires || l(e.cookies.expires)
              ? (g = a(e.cookies.expires))
              : e.cookies.expires.tracking &&
                ('number' == typeof e.cookies.expires.tracking ||
                  l(e.cookies.expires.tracking)) &&
                (g = a(e.cookies.expires.tracking))),
            g && g < new Date() && (g = void 0))
          const k =
            e.target +
            '/webxp/streams/' +
            e.stream_id +
            '/' +
            t +
            '/' +
            (u.exec(m.cookie) || [0, 'new'])[1] +
            '/modifications.min.js?http-referer=' +
            _ +
            '&timeout=' +
            d +
            'ms' +
            (g ? '&cookie-expires=' + Math.floor(g.getTime() / 1e3) : '')
          'sync' === e.new_experiments.mode &&
          r.localStorage.getItem('__exponea__sync_modifications__')
            ? (function (e, t, n, i, o) {
                ;((n[o][t] = '<' + t + ' src="' + e + '"></' + t + '>'),
                  i.writeln(n[o][t]),
                  i.writeln(
                    '<' +
                      t +
                      '>!' +
                      o +
                      '.init && document.writeln(' +
                      o +
                      '.' +
                      t +
                      '.replace("/' +
                      t +
                      '/", "/' +
                      t +
                      '-async/").replace("><", " async><"))</' +
                      t +
                      '>'
                  ))
              })(k, t, r, m, n)
            : (function (e, t, n, i, o, r, s, c) {
                r.documentElement.classList.add(e)
                const a = p(n, i, r)
                function m() {
                  o[c].init ||
                    p(n.replace('/' + i + '/', '/' + i + '-async/'), i, r)
                }
                function l() {
                  r.documentElement.classList.remove(e)
                }
                ;((a.onload = m),
                  (a.onerror = m),
                  o.setTimeout(l, t),
                  (o[s]._revealPage = l))
              })(f, d, k, t, r, m, o, n)
        })(r, n, i, 0, t, o, e, RegExp('__exponea_etc__' + '=([\\w-]+)')),
        (function (e, t, n) {
          var i
          ;(e[t]._initializeConfig(n),
            (null === (i = n.experimental) || void 0 === i
              ? void 0
              : i.non_personalized_weblayers) && e[t]._preInitialize(n),
            (e[t].start = function (i) {
              ;(i && Object.keys(i).forEach((e) => (n[e] = i[e])),
                e[t].initialize(n))
            }))
        })(o, t, r))
    })(document, 'brweb', 'script', 'webxpClient', window, {
      target: 'https://cdp.talkingparents.com',
      stream_id: import.meta.env.VITE_APP_BLOOMREACH_STREAM_ID,
      track: {
        google_analytics: false,
        metadata: { debug: isNonProduction, test_data: isNonProduction }
      },
      push: {
        safari: { websitePushID: import.meta.env.VITE_APP_WEBSITE_PUSH_ID }
      },
      ping: { activity: false },
      spa_reloading: {
        on_url_change: true,
        automatic_tracking: true,
        banners: false
      },
      new_experiments: { experiments: true, tagManager: true, webLayers: true },
      debug: false
    })
    window.brweb.start()

    app.provide('$trackingStart', function () {
      window.brweb.start()
    })

    app.provide('$trackingIdentify', function (payload: ITrackingIdentity) {
      window.brweb.identify(
        {
          talkingparents_id: payload.talkingparents_id,
          email_id: payload.email
        },
        {},
        function () {
          //success callback
        },
        function () {
          // error callback
        },
        false
      )
    })

    app.provide(
      '$trackingIdentifyWithProperties',
      function (payload: ITrackingIdentity) {
        window.brweb.identify(
          {
            talkingparents_id: payload.talkingparents_id,
            email_id: payload.email
          },
          {
            first_name: payload.firstName,
            last_name: payload.lastName,
            email: payload.email,
            matched: payload.matched
          },
          function () {
            //success callback
          },
          function () {
            // error callback
          },
          false
        )
      }
    )

    app.provide(
      '$trackingIdentifyWithId',
      function (payload: ITrackingIdentity) {
        window.brweb.identify(
          {
            talkingparents_id: payload.talkingparents_id,
            email_id: payload.email
          },
          {
            first_name: payload.firstName,
            last_name: payload.lastName,
            email: payload.email,
            matched: payload.matched
          },
          function () {
            //success callback
          },
          function () {
            // error callback
          },
          false
        )
      }
    )

    app.provide(
      '$trackingIdentifyAndConsent',
      function (payload: ITrackingIdentity) {
        window.brweb.identify(
          {
            talkingparents_id: payload.talkingparents_id,
            email_id: payload.email
          },
          {
            first_name: payload.firstName,
            last_name: payload.lastName,
            email: payload.email,
            matched: payload.matched
          },
          function () {
            //success callback
            if (payload.consent) {
              window.brweb.track('consent', {
                action: 'accept',
                category: 'Email',
                valid_until: 'unlimited'
              })
              window.brweb.track('consent', {
                action: 'accept',
                category: 'releases_and_updates',
                valid_until: 'unlimited'
              })
              window.brweb.track('consent', {
                action: 'accept',
                category: 'Feedback',
                valid_until: 'unlimited'
              })
            }
          },
          function () {
            // error callback
          },
          false
        )
      }
    )

    app.provide(
      '$trackingEmailIdentifyAndConsent',
      function (payload: ITrackingIdentity) {
        window.brweb.identify(
          { email_id: payload.email },
          { email: payload.email },
          function () {
            //success callback
            if (payload.consent) {
              window.brweb.track('consent', {
                action: 'accept',
                category: 'Email',
                valid_until: 'unlimited'
              })
              window.brweb.track('consent', {
                action: 'accept',
                category: 'releases_and_updates',
                valid_until: 'unlimited'
              })
              window.brweb.track('consent', {
                action: 'accept',
                category: 'Feedback',
                valid_until: 'unlimited'
              })
            }
          },
          function () {
            // error callback
          },
          false
        )
      }
    )

    app.provide(
      '$trackingTrack',
      function (eventType: string, payload: ITrackingEvent) {
        if (
          eventType == br.eventTypes.signup &&
          hasBeenTracked(eventType, payload)
        )
          return
        const _payload = {
          timestamp: DateTime.now().toUnixInteger(),
          source: 'web'
        }
        window.brweb.track(eventType, { ..._payload, ...payload })
      }
    )

    app.provide('$trackingUpdate', function (payload: ITrackingUpdate) {
      window.brweb.update(payload)
    })

    app.provide('$trackingAnonymize', function () {
      window.brweb.anonymize()
    })

    app.provide(
      '$trackingGetConsentUrl',
      async function (payload: ITrackingIdentity): string {
        const cookieName = '__exponea_etc__'
        const cookieValue = document.cookie
          .split('; ')
          .find((row) => row.startsWith(cookieName))
          ?.split('=')[1]

        const url = payload.email
          ? '/web/api/Ctd/GetConsentsUrl'
          : '/web/api/Ctd/GetConsentsUrlFromCookie'

        const params = { Email: payload.email, Cookie: cookieValue }

        const response = await httpClient.get(url, { params: params })

        return response.data.value
      }
    )

    app.provide('$trackingLaunchWebLayer', function (webLayerId: string) {
      if (webLayerId && webLayerId.lenght == 0) return
      window.brweb.showWebLayer(webLayerId)
    })

    // private functions
    const _handledEventList: { eventType: string; payload: ITrackingEvent }[] =
      []
    function hasBeenTracked(eventType: string, payload: ITrackingEvent) {
      const _eventType = eventType
      const result = _handledEventList.find((e) => {
        return !!(
          e.eventType == _eventType &&
          e.payload.step == payload.step &&
          e.payload.field == payload.field &&
          e.payload.action == payload.action
        )
      })
      if (result == undefined) {
        _handledEventList.push({ eventType, payload })
      }
      return result != undefined
    }
  }
}

// exposing constants for bloomreach

export const br = Object.freeze({
  eventTypes: {
    signup: 'signup',
    subscription: 'subscription',
    appAction: 'app_action',
    appNavigation: 'app_navigation',
    newsletterSignup: 'newsletter_signup'
  },
  signupEventStep: {
    verifyEmail: 1,
    accountInformation: 2,
    mfaAndQuickMatch: 3,
    matchInformation: 4,
    editInformation: 5
  },
  signupEventAction: {
    fieldCompleted: 'field_completed',
    deletedAccount: 'deleted_account',
    //STEP 1
    sendVerifyEmail: 'send_verify_email',
    verifyEemail: 'verify_email',

    //STEP 2
    agreeAndContinue: 'agree_and_continue',

    //STEP 3
    skipMfa: 'skip_mfa',
    sendMfa: 'send_mfa',
    verifyMfa: 'verify_mfa',
    skipMatchid: 'skip_matchid',
    useMatchid: 'use_matchid',
    verifyMatchid: 'verify_matchid',
    skipEmail: 'skip_email',
    useEmail: 'use_email',
    quickmatchEmail: 'quickmatch_email',
    stepThreeSignout: 'step_three_signout',

    //STEP 4
    setMatchInfo: 'set_match_info',
    emailInvite: 'email_invite',
    textInvite: 'text_invite',
    copyMatchid: 'copy_matchid',
    stepFourSignout: 'step_four_signout',

    //STEP 5
    updatedInformation: 'updated_information'
  },
  signupEventField: {
    email: 'email',

    //STEP 2
    firstName: 'first_name',
    lastName: 'last_name',
    password: 'password',
    verifyPassword: 'verify_password',
    timezone: 'timezone',
    agreeBox: 'agree_box',

    //STEP 3
    mfaPhonenumber: 'mfa_phonenumber',
    matchid: 'matchid',
    coparentEmail: 'coparent_email',

    //STEP 4
    coparentFirstName: 'coparent_first_name',
    coparentLastName: 'coparent_last_name',
    childFirstName: 'child_first_name',
    childDob: 'child_dob',

    //Step 5
    updateFirstName: 'update_first_name',
    updateLastName: 'update_last_name',
    updateTimezone: 'update_timezone',
    updateCoparentFirstName: 'update_coparent_first_name',
    updateCoparentLastName: 'update_coparent_last_name',
    updateCoparentEmail: 'update_coparent_email',
    updateChildDob: 'update_child_dob',
    updatePhone: 'update_phone',
    updateChildFirstName: 'update_Child_first_name'
  },
  appActionEventNames: {
    navigation: 'navigation',
    CTAUpgrade: 'cta_upgrade',
    videoCompleted: 'video_completed',
    phoneEnabled: 'phone_enabled',
    videoEnabled: 'video_enabled',
    createdConversation: 'created_conversation',
    attachmentUploaded: 'attachment_uploaded',
    pdfPurchaseCompleted: 'pdf_purchase_completed',
    printedPurchaseCompleted: 'printed_purchase_completed',
    createdEntry: 'created_entry',
    bankAdded: 'bank_added',
    successfulTransfer: 'successful_transfer',
    createdCard: 'created_card',
    createdTab: 'created_tab',
    itemUploaded: 'item_uploaded',
    emailVerified: 'email_verified',
    phoneVerified: 'phone_verified',
    biometricsDiabled: 'biometrics_disabled',
    biometricsEnabled: 'biometrics_enabled',
    feedbackButton: 'feedback_button',
    CTAEmailSignup: 'cta_email_signup'
  },
  appActionFeature: {
    calling: 'calling',
    messages: 'messaging',
    records: 'records',
    calendar: 'calendar',
    payments: 'payments',
    infoLibrary: 'info_library',
    vault: 'vault',
    journal: 'journal',
    settings: 'settings'
  },
  appNavigationProperties: { from: 'from_location', to: 'to_location' }
})
